export default __webpack_public_path__ + "static/media/ic_note_pre_order.930912c9.png";